document.addEventListener('DOMContentLoaded', function() {

  function handleCheckboxChange(checkbox) {
    const hiddenInputId = checkbox.dataset.hiddenInputId;
    const hiddenInput = document.getElementById(hiddenInputId);
    if (hiddenInput) {
      hiddenInput.value = checkbox.checked ? 'Yes' : 'No';
    }
  }

  function handleTextInputChange(input) {
    const hiddenInputId = input.dataset.hiddenInputId;
    const hiddenInput = document.getElementById(hiddenInputId);
    if (hiddenInput) {
      hiddenInput.value = input.value;
    }
  }

  // Build the line item property value from key + label.
  // See docs/adr/0001-bundle-product-frame-color-as-metafield.md
  function getLineItemValue(input) {
    var label;
    if (input.tagName === 'SELECT') {
      var selected = input.options[input.selectedIndex];
      label = selected && selected.dataset.optionLabel;
    } else {
      label = input.dataset.optionLabel;
    }
    if (label) {
      return label + ' (' + input.value + ')';
    }
    return input.value;
  }

  function handleOptionInputChange(optionInputs) {
    optionInputs.forEach(input => {
      const productFormInput = document.getElementById(`product-form-input-${input.dataset.optionName}-${input.dataset.blockId}`);
      if (!productFormInput) {
        return;
      }

      function updateFields(input) {
        productFormInput.value = getLineItemValue(input);
      }

      input.addEventListener('change', function() {
        updateFields(this);
      });

      if (input.checked || input.tagName === 'SELECT') {
        updateFields(input);
      }
    });
  }

  const customCheckboxes = document.querySelectorAll('.custom-checkbox-input');
  customCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      handleCheckboxChange(checkbox);
    });
  });

  const customTextInputs = document.querySelectorAll('.custom-text-field');
  customTextInputs.forEach(input => {
    input.addEventListener('input', function() {
      handleTextInputChange(input);
    });
  });

  const optionInputs = document.querySelectorAll('input[name^="custom_option_"], select[name^="custom_option_"]');
  if (optionInputs.length > 0) {
    handleOptionInputChange(optionInputs);
  }

  // Thumbnail scroller: toggle active class + update label
  document.querySelectorAll('.frame-thumbnail input[type="radio"]').forEach(function(radio) {
    radio.addEventListener('change', function() {
      var track = this.closest('.frame-thumbnail-track');
      if (track) {
        track.querySelectorAll('.frame-thumbnail').forEach(function(t) {
          t.classList.remove('frame-thumbnail--active');
        });
        this.closest('.frame-thumbnail').classList.add('frame-thumbnail--active');
      }
      var labelSpan = document.getElementById('selected' + this.dataset.optionName);
      if (labelSpan) {
        labelSpan.textContent = this.dataset.optionLabel;
      }
    });
  });

  // Frame Model -> Gallery image swap
  function initFrameMediaSwap() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const mapAttr = gallery.getAttribute('data-frame-media-map');
    if (!mapAttr) return;

    let frameMediaMap;
    try {
      frameMediaMap = JSON.parse(mapAttr);
    } catch (e) {
      return;
    }

    const allFrameValues = Object.keys(frameMediaMap);
    if (allFrameValues.length === 0) return;

    // Collect all media IDs that belong to ANY frame model
    const allFrameMediaIds = new Set();
    for (const ids of Object.values(frameMediaMap)) {
      ids.forEach(id => allFrameMediaIds.add(id));
    }

    function filterGallery(selectedValue) {
      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
      if (!viewer) return;

      const allSlides = viewer.querySelectorAll('[data-media-id]');
      const allThumbs = thumbnails
        ? thumbnails.querySelectorAll('[data-target]')
        : [];

      const matchingIds = frameMediaMap[selectedValue] || [];
      const matchingSet = new Set(matchingIds);
      let firstMatchId = null;

      allSlides.forEach(slide => {
        const mediaId = slide.dataset.mediaId;
        if (allFrameMediaIds.has(mediaId)) {
          // This image belongs to a frame model
          if (matchingSet.has(mediaId)) {
            slide.style.display = '';
            if (!firstMatchId) firstMatchId = mediaId;
          } else {
            slide.style.display = 'none';
            slide.classList.remove('is-active');
          }
        }
        // Images not in any frame group stay visible (generic images)
      });

      allThumbs.forEach(thumb => {
        const target = thumb.dataset.target;
        if (allFrameMediaIds.has(target)) {
          thumb.style.display = matchingSet.has(target) ? '' : 'none';
        }
      });

      // Activate the first matching image
      if (firstMatchId && gallery.setActiveMedia) {
        gallery.setActiveMedia(firstMatchId, false);
      } else if (firstMatchId) {
        const firstMatch = viewer.querySelector(
          `[data-media-id="${firstMatchId}"]`
        );
        if (firstMatch) {
          allSlides.forEach(s => s.classList.remove('is-active'));
          firstMatch.classList.add('is-active');
        }
      }

      // Update slider counter if present
      const counter = gallery.querySelector('.slider-counter--total');
      if (counter) {
        const visibleCount = viewer.querySelectorAll(
          '[data-media-id]:not([style*="display: none"])'
        ).length;
        counter.textContent = visibleCount;
      }

      // Reset slider position
      const sliderEl = viewer.querySelector('.slider');
      if (sliderEl) sliderEl.scrollTo({ left: 0 });
    }

    // Listen to all custom option inputs (radios and selects)
    const optionInputs = document.querySelectorAll(
      'input[name^="custom_option_"], select[name^="custom_option_"]'
    );
    optionInputs.forEach(input => {
      input.addEventListener('change', function () {
        filterGallery(this.value);
      });
    });

    // Apply on page load for the initially selected value
    const initialInput = document.querySelector(
      'input[name^="custom_option_"]:checked, select[name^="custom_option_"]'
    );
    if (initialInput) {
      filterGallery(initialInput.value);
    }
  }

  initFrameMediaSwap();

  // Rich Select Dropdown: replace lens option selects with descriptive dropdowns
  function initRichSelects() {
    var lang = (document.documentElement.lang || 'en').substring(0, 2);

    var descriptions = {
      en: {
        'Single Vision': { desc: 'Stock lens. Near or far correction.' },
        'Single Vision Custom Made': { desc: 'Custom ground to your Rx. Thinner, lighter, stronger prescriptions.' },
        'Progressive / Varifocal': { desc: 'Custom ground to your Rx. Near + far in one lens.' },
        'High Index 1.6': { desc: 'Thinnest. Not for sport.', price: '$' },
        'Polycarbonate': { desc: 'Sport all-rounder', price: '$$' },
        'Trivex': { desc: 'Best sport lens. Lightest. Clearest.', price: '$$$' },
        'No Coating': { desc: 'Basic lens' },
        'Anti-Scratch': { desc: '+ scratch protection' },
        'Anti-Reflective': { desc: '+ glare reduction' },
        'Hydrophobic (Anti-Fog)': { desc: '+ water & fog repellent' }
      },
      de: {
        'Single Vision': { desc: 'Lagerglas. Korrektur für Nähe oder Ferne.' },
        'Einstärken': { desc: 'Lagerglas. Korrektur für Nähe oder Ferne.' },
        'Single Vision Custom Made': { desc: 'Individuell geschliffen. Dünner, leichter, stärkere Korrekturen.' },
        'Progressive / Varifocal': { desc: 'Individuell geschliffen. Nähe + Ferne in einem Glas.' },
        'Progressiv (Gleitsicht)': { desc: 'Individuell geschliffen. Nähe + Ferne in einem Glas.' },
        'High Index 1.6': { desc: 'Dünnste Option. Nicht für Sport.', price: '$' },
        'Hoher Index 1,6': { desc: 'Dünnste Option. Nicht für Sport.', price: '$' },
        'Polycarbonate': { desc: 'Sport-Allrounder', price: '$$' },
        'Polycarbonat': { desc: 'Sport-Allrounder', price: '$$' },
        'Trivex': { desc: 'Bestes Sportglas. Leichtestes. Klarstes.', price: '$$$' },
        'No Coating': { desc: 'Grundglas' },
        'Keine Beschichtung': { desc: 'Grundglas' },
        'Anti-Scratch': { desc: '+ Kratzschutz' },
        'Kratzfest': { desc: '+ Kratzschutz' },
        'Anti-Reflective': { desc: '+ Entspiegelung' },
        'Entspiegelt': { desc: '+ Entspiegelung' },
        'Antireflex': { desc: '+ Entspiegelung' },
        'Hydrophobic (Anti-Fog)': { desc: '+ Wasser- & Beschlagabweisung' },
        'Hydrophob (Anti-Beschlag)': { desc: '+ Wasser- & Beschlagabweisung' }
      },
      fr: {
        'Single Vision': { desc: 'Verre de stock. Correction de pres ou de loin.' },
        'Single Vision Custom Made': { desc: 'Taille sur mesure. Plus fin, plus leger, corrections plus fortes.' },
        'Progressive / Varifocal': { desc: 'Taille sur mesure. Pres + loin dans un seul verre.' },
        'Progressifs': { desc: 'Taille sur mesure. Pres + loin dans un seul verre.' },
        'High Index 1.6': { desc: 'Le plus fin. Pas pour le sport.', price: '$' },
        'Polycarbonate': { desc: 'Polyvalent pour le sport', price: '$$' },
        'Trivex': { desc: 'Meilleur verre sport. Plus leger. Plus clair.', price: '$$$' },
        'No Coating': { desc: 'Verre de base' },
        'Anti-Scratch': { desc: '+ anti-rayures' },
        'Anti-Reflective': { desc: '+ anti-reflet' },
        'Hydrophobic (Anti-Fog)': { desc: '+ hydrophobe anti-buee' }
      }
    };

    var descs = descriptions[lang] || descriptions['en'];
    var caretSvg = '<svg class="rich-select__caret" viewBox="0 0 10 6" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M1 1l4 4 4-4"/></svg>';

    var panelHeaders = {
      en: {
        '1': 'Not sure which to pick? No worries. We check every order against your prescription and will contact you if something doesn\'t match.'
      },
      de: {
        '1': 'Nicht sicher, welches Glas? Kein Problem. Wir prüfen jede Bestellung anhand deiner Korrekturwerte und melden uns, falls etwas nicht passt.'
      },
      fr: {
        '1': 'Pas sur de votre choix? Pas de souci. Nous verifions chaque commande avec votre ordonnance et vous contactons si quelque chose ne correspond pas.'
      }
    };
    var headers = panelHeaders[lang] || panelHeaders['en'];

    var panelFooters = {
      en: {
        '2': { text: 'Choose based on your activity.' },
        '3': { text: '' }
      },
      de: {
        '2': { text: 'Wähle anhand deiner Aktivität.' },
        '3': { text: '' }
      },
      fr: {
        '2': { text: 'Choisissez selon votre activite.' },
        '3': { text: '' }
      }
    };

    var comparisonTables = {
      en: {
        '2': {
          cols: ['Thin', 'Sport', 'Light', 'Clear'],
          rows: [
            { label: 'High Index 1.6', value: 'High Index 1.6', checks: [true, false, false, true] },
            { label: 'Polycarbonate', value: 'Polycarbonate', checks: [true, true, false, false] },
            { label: 'Trivex', value: 'Trivex', checks: [true, true, true, true] }
          ]
        },
        '3': {
          cols: ['Anti Scratch', 'Anti Reflective', 'Anti Fog'],
          rows: [
            { label: 'No Coating', value: 'No Coating', checks: [false, false, false] },
            { label: 'Anti-Scratch', value: 'Anti-Scratch', checks: [true, false, false] },
            { label: 'Anti-Reflective', value: 'Anti-Reflective', checks: [true, true, false] },
            { label: 'Hydrophobic', value: 'Hydrophobic (Anti-Fog)', checks: [true, true, true] }
          ]
        }
      },
      de: {
        '2': {
          cols: ['Dünn', 'Sport', 'Leicht', 'Klar'],
          rows: [
            { label: 'High Index 1.6', value: 'High Index 1.6', checks: [true, false, false, true] },
            { label: 'Polycarbonat', value: 'Polycarbonate', checks: [true, true, false, false] },
            { label: 'Trivex', value: 'Trivex', checks: [true, true, true, true] }
          ]
        },
        '3': {
          cols: ['Kratzfest', 'Entspiegelt', 'Anti-Beschlag'],
          rows: [
            { label: 'Ohne', value: 'No Coating', checks: [false, false, false] },
            { label: 'Kratzfest', value: 'Anti-Scratch', checks: [true, false, false] },
            { label: 'Entspiegelt', value: 'Anti-Reflective', checks: [true, true, false] },
            { label: 'Hydrophob', value: 'Hydrophobic (Anti-Fog)', checks: [true, true, true] }
          ]
        }
      },
      fr: {
        '2': {
          cols: ['Fin', 'Sport', 'Leger', 'Clair'],
          rows: [
            { label: 'High Index 1.6', value: 'High Index 1.6', checks: [true, false, false, true] },
            { label: 'Polycarbonate', value: 'Polycarbonate', checks: [true, true, false, false] },
            { label: 'Trivex', value: 'Trivex', checks: [true, true, true, true] }
          ]
        },
        '3': {
          cols: ['Anti-rayures', 'Anti-reflet', 'Anti-buee'],
          rows: [
            { label: 'Aucun', value: 'No Coating', checks: [false, false, false] },
            { label: 'Anti-rayures', value: 'Anti-Scratch', checks: [true, false, false] },
            { label: 'Anti-reflet', value: 'Anti-Reflective', checks: [true, true, false] },
            { label: 'Hydrophobe', value: 'Hydrophobic (Anti-Fog)', checks: [true, true, true] }
          ]
        }
      }
    };
    var tables = comparisonTables[lang] || comparisonTables['en'];
    var footers = panelFooters[lang] || panelFooters['en'];
    var moreInfoLabel = { en: 'More info', de: 'Mehr Info', fr: 'Plus d\'infos' };
    var moreInfoText = moreInfoLabel[lang] || moreInfoLabel['en'];

    var variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    var wrappers = variantSelects.querySelectorAll('.product-form__input--dropdown');

    wrappers.forEach(function(wrapper) {
      if (wrapper.querySelector('.rich-select')) return;

      var select = wrapper.querySelector('select');
      if (!select) return;

      var options = Array.from(select.options);
      var matchCount = options.filter(function(opt) { return descs[opt.value]; }).length;
      if (matchCount < options.length * 0.5) return;

      var selectedOpt = select.options[select.selectedIndex];
      var selectedInfo = descs[selectedOpt.value];

      // Build dropdown container
      var dropdown = document.createElement('div');
      dropdown.className = 'rich-select';

      // Trigger button
      var trigger = document.createElement('div');
      trigger.className = 'rich-select__trigger';
      var triggerHtml = '<span class="rich-select__trigger-text">' + selectedOpt.textContent.trim() + '</span>';
      triggerHtml += caretSvg;
      trigger.innerHTML = triggerHtml;

      // Panel
      var panel = document.createElement('div');
      panel.className = 'rich-select__panel';

      var optionPosition = wrapper.getAttribute('data-option-position');
      var tableData = tables[optionPosition];

      // Helper to update trigger text
      function updateTrigger(value, text) {
        var html = '<span class="rich-select__trigger-text">' + text + '</span>';
        html += caretSvg;
        trigger.innerHTML = html;
      }

      // Helper to select a value
      function selectValue(value, text, container) {
        container.querySelectorAll('[data-value]').forEach(function(el) {
          el.classList.remove('rich-select__option--selected', 'rich-select__row--selected');
        });
        var target = container.querySelector('[data-value="' + value + '"]');
        if (target) target.classList.add(tableData ? 'rich-select__row--selected' : 'rich-select__option--selected');

        updateTrigger(value, text);
        dropdown.classList.remove('rich-select--open');
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (tableData) {
        // Table-based panel: rows are selectable
        var tableEl = document.createElement('div');
        tableEl.className = 'rich-select__table';
        var tableHtml = '<table class="rich-select__grid"><thead><tr><th></th>';
        tableData.cols.forEach(function(col) {
          tableHtml += '<th>' + col + '</th>';
        });
        tableHtml += '</tr></thead><tbody>';
        tableData.rows.forEach(function(rowData) {
          // Match option by hardcoded value first, then fall back to description key lookup
          var opt = options.find(function(o) { return o.value === rowData.value; })
                || options.find(function(o) { return descs[o.value] && descs[o.value].desc === (descs[rowData.value] || {}).desc; });
          var actualValue = opt ? opt.value : rowData.value;
          var isSelected = opt && (opt.selected || opt.getAttribute('selected') === 'selected');
          var rowLabel = opt ? opt.textContent.trim() : rowData.label;
          tableHtml += '<tr data-value="' + actualValue + '"' + (isSelected ? ' class="rich-select__row--selected"' : '') + '>';
          tableHtml += '<td class="rich-select__row-label">' + rowLabel + '</td>';
          rowData.checks.forEach(function(checked) {
            tableHtml += '<td>' + (checked ? '<span class="rich-select__check">&#10003;</span>' : '') + '</td>';
          });
          tableHtml += '</tr>';
        });
        tableHtml += '</tbody></table>';
        tableEl.innerHTML = tableHtml;

        // Bind click on each row
        tableEl.querySelectorAll('tr[data-value]').forEach(function(tr) {
          tr.addEventListener('click', function(e) {
            e.stopPropagation();
            var val = tr.dataset.value;
            var opt = options.find(function(o) { return o.value === val; });
            if (!opt || opt.disabled) return;
            selectValue(val, opt.textContent.trim(), tableEl);
          });
        });

        panel.appendChild(tableEl);
      } else {
        // Radio-button option rows (default)
        options.forEach(function(opt) {
          var info = descs[opt.value];
          var isSelected = opt.selected || opt.getAttribute('selected') === 'selected';

          var row = document.createElement('div');
          row.className = 'rich-select__option' +
            (isSelected ? ' rich-select__option--selected' : '') +
            (opt.disabled ? ' rich-select__option--disabled' : '');
          row.dataset.value = opt.value;

          var html = '<div class="rich-select__radio"></div>';
          html += '<div class="rich-select__content">';
          html += '<div class="rich-select__name">';
          html += '<span>' + opt.textContent.trim() + '</span>';
          if (info && info.price) html += '<span class="rich-select__price">' + info.price + '</span>';
          html += '</div>';
          if (info) {
            html += '<div class="rich-select__desc">' + info.desc + '</div>';
            if (info.warning) html += '<div class="rich-select__warning">' + info.warning + '</div>';
          }
          html += '</div>';

          row.innerHTML = html;

          row.addEventListener('click', function(e) {
            e.stopPropagation();
            if (opt.disabled) return;
            selectValue(opt.value, opt.textContent.trim(), panel);
          });

          panel.appendChild(row);
        });
      }

      // Reassurance message
      var headerText = headers[optionPosition];
      if (headerText) {
        var reassurance = document.createElement('div');
        reassurance.className = 'rich-select__header';
        reassurance.textContent = headerText;
        panel.appendChild(reassurance);
      }

      // Panel footer (disclaimer + more info link)
      var footerData = footers[optionPosition];
      if (footerData) {
        var footer = document.createElement('div');
        footer.className = 'rich-select__footer';
        var footerHtml = '';
        if (footerData.text) footerHtml += '<span class="rich-select__footer-text">' + footerData.text + '</span>';
        footerHtml += '<a href="#" class="rich-select__footer-link">' + moreInfoText + '</a>';
        footer.innerHTML = footerHtml;
        footer.querySelector('.rich-select__footer-link').addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          dropdown.classList.remove('rich-select--open');
          var infoLink = wrapper.querySelector('.option-info-link');
          if (infoLink) infoLink.click();
        });
        panel.appendChild(footer);
      }

      // Toggle open/close
      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        // Close any other open rich-selects
        document.querySelectorAll('.rich-select--open').forEach(function(other) {
          if (other !== dropdown) other.classList.remove('rich-select--open');
        });
        dropdown.classList.toggle('rich-select--open');
      });

      dropdown.appendChild(trigger);
      dropdown.appendChild(panel);

      var selectDiv = wrapper.querySelector('.select');
      if (selectDiv) {
        wrapper.insertBefore(dropdown, selectDiv);
      }
    });

    // Close on outside click (only bind once)
    if (!window._richSelectOutsideClickBound) {
      window._richSelectOutsideClickBound = true;
      document.addEventListener('click', function() {
        document.querySelectorAll('.rich-select--open').forEach(function(d) {
          d.classList.remove('rich-select--open');
        });
      });
    }
  }

  initRichSelects();

  // Re-initialize after variant-selects re-renders (section rendering API)
  var richSelectTimer = null;
  var sectionEl = document.querySelector('variant-selects')?.closest('.shopify-section');
  if (sectionEl) {
    new MutationObserver(function() {
      clearTimeout(richSelectTimer);
      richSelectTimer = setTimeout(initRichSelects, 50);
    }).observe(sectionEl, { childList: true, subtree: true });
  }
});
